import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const BaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');
const BaseEmails = () => import('@/views/dashboard/emails/BaseEmails.vue');

const emailsRoutes: RouteRecordRaw[] = [
    {
        path: '/emails',
        components: {
            default: BaseDashboard,
        },
        meta: {
            title: 'emails',
            icon: 'mdi-email-outline',
            noCache: false,
            isBase: true,
            permissions: ['orders_view'],
            showInMenu: true,
            middleware: ['auth'],
            layout: 'Dashboard',
            showNewUntil: '2026-09-01',
        } as CommonRouteMeta,
        children: [
            {
                path: '',
                components: {
                    default: BaseEmails,
                },
                name: 'emails.index',
                meta: {title: 'emails', icon: 'mdi-email-outline', noCache: false, isBase: true},
            },
        ],
    }
];

export default emailsRoutes;
